import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button } from 'antd';
import React, { useState } from 'react';
import { EXPORT_TYPES, MODULES } from '../../../../../common/constants';
import Portal from '../../../../../components/Portal';
import AllDeliveryTable from '../../all/components/AllDeliveryTable';
import AutoAssignStaffButton from '../components/AutoAssignStaffButton';
import NewTabs from '../components/NewTabs';
import { REQUEST_NEW_ORDER_EXPORT } from '../graphql/Mutations';

const New = () => {
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [staffSyncKey, setStaffSyncKey] = useState(0);

  const handleStaffAutoAssigned = () => setStaffSyncKey((key) => key + 1);

  const [requestOrderExport] = useMutation(REQUEST_NEW_ORDER_EXPORT, {
    onError: () => {},
  });

  const handleExport = async () => {
    setIsExportLoading(true);
    await requestOrderExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.NEW_ORDERS,
        },
        filter: {
          search: exportFilter?.search,
          deliveryType: exportFilter?.deliveryType,
          orderIds: exportFilter?.orderNumber,
          dateRange: {
            from: exportFilter?.createdAt?.from?.$d,
            to: exportFilter?.createdAt?.to?.$d,
          },
          pincodeIds: exportFilter?.pincodes,
          orderTypes:
            exportFilter?.orderTypes?.length > 0
              ? exportFilter?.orderTypes
              : undefined,
        },
      },
    });
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.CONFIRM_ORDER}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <AutoAssignStaffButton onSuccess={handleStaffAutoAssigned} />
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={handleExport}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <AutoAssignStaffButton onSuccess={handleStaffAutoAssigned} />
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={handleExport}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <div className="tab-table">
        <NewTabs>
          <div className="tab-table">
            <AllDeliveryTable
              exportFilter={exportFilter}
              setExportFilter={setExportFilter}
              isTruckIconVisible={false}
              staffSyncKey={staffSyncKey}
            />
          </div>
        </NewTabs>
      </div>
    </>
  );
};

export default New;
